import type { ApolloError } from "@apollo/client";
import type { MostRecentIssueWithClosedEventWithoutFeedbackQuery } from "@medbillai/graphql-types";
import { Paragraph, XStack, YStack } from "@medbillai/ui";
import { BackgroundRadialGrantedGradient } from "../../../components/BackgroundRadialGrantedGradient";
import { GradientStar } from "../../../components/local-images/LocalImages";
import { useFeedbackDialog } from "../../../hooks/useFeedbackDialog";
import { FeedbackDialog } from "./FeedbackDialog";
import { IssueSummary } from "./IssueSummary";
import { WidgetWrapper } from "./WidgetWrapper";
type ClosedEvent = NonNullable<MostRecentIssueWithClosedEventWithoutFeedbackQuery["issue__ClosedEvent"]>[number];
type ResolvedCaseProps = {
  closedEvent: ClosedEvent | null;
  error: ApolloError | undefined;
};
export function ResolvedCase({
  closedEvent,
  error
}: ResolvedCaseProps) {
  const {
    handlePress,
    dialogProps
  } = useFeedbackDialog();

  // Don't show widget if there's an error or no data
  if (error || !closedEvent) {
    return null;
  }
  const {
    issue
  } = closedEvent;
  return <WidgetWrapper title="Closed cases" titleProps={{
    pb: "$0"
  }} data-sentry-element="WidgetWrapper" data-sentry-component="ResolvedCase" data-sentry-source-file="ResolvedCase.tsx">
      <IssueSummary issue={issue} stackProps={{
      marginHorizontal: "$-4",
      paddingHorizontal: "$4"
    }} data-sentry-element="IssueSummary" data-sentry-source-file="ResolvedCase.tsx" />

      {/* Feedback section */}
      <YStack mt="$3.5" padding="$4" alignItems="center" gap="$3" position="relative" zIndex={1} borderRadius="$4" overflow="hidden" data-sentry-element="YStack" data-sentry-source-file="ResolvedCase.tsx">
        <BackgroundRadialGrantedGradient fullscreen={false} zIndex={-1} data-sentry-element="BackgroundRadialGrantedGradient" data-sentry-source-file="ResolvedCase.tsx" />

        <Paragraph size="$4" color="$textDefault" data-sentry-element="Paragraph" data-sentry-source-file="ResolvedCase.tsx">
          How did we do?
        </Paragraph>

        <XStack gap="$2" data-sentry-element="XStack" data-sentry-source-file="ResolvedCase.tsx">
          {[1, 2, 3, 4, 5].map(star => <YStack key={star} onPress={() => handlePress(star)} hoverStyle={{
          scale: 1.1
        }} pressStyle={{
          scale: 1.1
        }} cursor="pointer" py="$1">
              <GradientStar width={30} height={30} />
            </YStack>)}
        </XStack>
      </YStack>

      <FeedbackDialog {...dialogProps} issueId={closedEvent.issue.id} data-sentry-element="FeedbackDialog" data-sentry-source-file="ResolvedCase.tsx" />
    </WidgetWrapper>;
}